import api from '../configs/api';
import helper from '../helpers/api';

const resource = 'notification';

export default {
  ...helper(resource),
  markAsRead: id => api.get(`${resource}/${id}/mark-as-read`),
};
